import React from 'react';
import { Link } from 'react-router-dom';
import bannerBg from "../../../assets/img/shape/banner-shape.png";
import award from "../../../assets/img/shape/award.png";
import image from "../../../assets/img/banner/banner.jpeg";

const BannerOne = () => {
    return (
        <div className="banner__one" style={{backgroundImage: `url(${bannerBg})`}}>
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="banner__one-content">
                            <h1 className="wow fadeInRight" data-wow-delay=".4s">Building Strong Roads, Stronger Infrastructure</h1>
                            <p className="wow fadeInUp mt-20 mb-40 text-white" data-wow-delay=".6s" style={{ fontSize: '18px', maxWidth: '700px', lineHeight: '1.6' }}>
                                Arclight Developers is a government-registered E-grade civil work company delivering dependable solutions in road construction, drainage lines, irrigation lines, pipeline work, beautification, and renovation projects.
                            </p>
                            {/* <div className="wow fadeInUp" data-wow-delay=".8s" style={{ display: 'flex', gap: '20px' }}>
                                <Link className="build_button" to="/contact-us">Contact Us<i className="flaticon-right-up"></i></Link>
                                <Link className="build_button" style={{ background: '#fff', color: '#1a1a1a' }} to="/portfolio/2-columns">View Gallery<i className="flaticon-right-up"></i></Link>
                            </div> */}
                            {/* <div className="banner__one-content-award bounce_y">
                                <img src={award} alt="image" />
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="banner__one-image">
                {/* --- FIX APPLIED HERE --- */}
                {/* objectFit keeps it filling the space, objectPosition pushes it down */}
                <img 
                    className="img_full" 
                    src={image} 
                    alt="Arclight Banner" 
                    style={{ objectFit: 'cover', objectPosition: 'center 10%' }} 
                />
            </div>
        </div>
    );
};

export default BannerOne;